import { render, staticRenderFns } from "./notes-historic.vue?vue&type=template&id=8adc38b8&"
import script from "./notes-historic.vue?vue&type=script&lang=js&"
export * from "./notes-historic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports